// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","warning":"#FFF3CD","warningBorder":"#F2A338","alert":"Alert_alert__ksdPG","alertWarning":"Alert_alertWarning__DPUD3"};